import {BundleVersion} from "./interface"

export default async function getBundleVersion(): BundleVersion {
  return "1.0"
}
